import { Eye, EyeSlash, InfoCircle } from 'iconsax-react';
import PropTypes from 'prop-types';
import { useState } from 'react';
import Text from '../../assets/styles/Text';
import * as styles from './styles';

export default function GroupInput({
  children,
  password = false,
  select = false,
  changePassword = false,
  error = null,
}) {
  const [passwordView, setPasswordView] = useState(true);

  function handlePasswordView() {
    setPasswordView((prevState) => !prevState);
  }

  return (
    <styles.Container
      $passwordView={passwordView && password}
      $error={error}
      $select={select}
    >
      {children}

      {error && (
        <styles.Error>
          <InfoCircle />
          <Text.Span>{error}</Text.Span>
        </styles.Error>
      )}

      {changePassword && (
        <styles.WrapChangePassword>
          <button type="button">
            <Text.P>Esqueci a minha senha</Text.P>
          </button>
        </styles.WrapChangePassword>
      )}

      {password && (
        <styles.ViewButton type="button" onClick={handlePasswordView}>
          {passwordView && <EyeSlash />}
          {!passwordView && <Eye />}
        </styles.ViewButton>
      )}
    </styles.Container>
  );
}

GroupInput.propTypes = {
  children: PropTypes.node.isRequired,
  password: PropTypes.bool,
  select: PropTypes.bool,
  changePassword: PropTypes.bool,
  error: PropTypes.string,
};
